// import React, { useState } from 'react'
// import Layouts from '../Layouts'
// import Address from '../Pages/CartPage/Address';
// import { PiDotsThreeOutlineVerticalFill } from 'react-icons/pi';
// import { Dropdown, Radio } from 'antd';

// const MyAddress = () => {
//     const [showAddressModal, setShowAddressModal] = useState(false);
//     const [open, setOpen] = useState(false);
//     const [open1, setOpen1] = useState(false);
//     const [selectedAddress, setSelectedAddress] = useState(null);

//     const handleMenuClick = (e, address) => {
//         if (e.key === '1') {
//             setSelectedAddress(address);
//             setShowAddressModal(true);
//             setOpen(false);
//         }
//     };

//     // const handleMenuClick = (e) => {
//     //     if (e.key === '2') {
//     //         setOpen(false);
//     //     }
//     // };
//     // const handleMenuClick1 = (e) => {
//     //     if (e.key === '2') {
//     //         setOpen(false);
//     //     }
//     // };

//     const handleMenuClick1 = (e, address) => {
//         if (e.key === '1') {
//             setSelectedAddress(address);
//             setShowAddressModal(true);
//             setOpen1(false);
//         }
//     };

    
//     const handleOpenChange = (nextOpen, info) => {
//         if (info.source === 'trigger' || nextOpen) {
//             setOpen(nextOpen);
//         }
//     };
//     const handleOpenChange1 = (nextOpen, info) => {
//         if (info.source === 'trigger' || nextOpen) {
//             setOpen1(nextOpen);
//         }
//     };

//     const items = [
//         {
//             label: 'Edit',
//             key: '1',
//         },
//         {
//             label: 'Delete',
//             key: '2',
//         },


//     ];

//     const handleRadioChange = (e) => {
//            setSelectedValue(e.target.value);
//         }
  


//         const [selectedValue, setSelectedValue] = useState('');
//     return (
//         <Layouts>
//             <div className='flex justify-center'>
//                 <div className='mx-5 my-5 bg-slate-50 w-[50%]   p-4 shadow-lg rounded-lg '>
//                     <div className=' flex justify-between items-center bg-popButtoncolour p-3'>
//                         <h1 className='text-3xl font-medium text-primaryColor'>My Address</h1>

//                         <Address visible={showAddressModal} onCancel={() => setShowAddressModal(false)} />
//                         <button className='border bg-popButtoncolour p-3 font-medium text-white rounded-md ' onClick={() => setShowAddressModal(true)} >
//                             ADD A NEW ADDRESS
//                         </button>
//                     </div>
//                     {/* <div className='p-3'>
//                     No addresses were saved yet
//                 </div> */}
//                     <div className='border p-3 mt-4  '>
//                         <div className='flex justify-between'>
//                             <div>
//                                 {/* <Radio
//                                     value="option1"
//                                     onChange={handleRadioChange}
//                                     checked={selectedValue === 'option1'}
//                                 /> */}
//                             </div>
//                             <div className='flex justify-between w-full '>
//                                 <div className='flex justify-between w-full'>

//                                     <div className='flex justify-between w-[20%]'>
//                                         <span className='font-semibold'>Hari haran </span>
//                                         <div className="text-primaryColor bg-secondaryColor  px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer">
//                                             Home
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div >
//                                 <Dropdown
//                                     menu={{
//                                         items, onClick: (e) => handleMenuClick(e, 'address1'),
//                                         // onClick: handleMenuClick, 
//                                     }}
//                                     onOpenChange={handleOpenChange}
//                                     open={open}
//                                 >

//                                     <PiDotsThreeOutlineVerticalFill
//                                         style={{ cursor: "pointer", fontSize: "25px", }}
//                                     />
//                                 </Dropdown>
//                             </div>
//                         </div>
//                         <div className=''>
//                             <p>
//                                 Address:
//                                 <span className='font-light'> 29, south street, mount, chennai-600001</span>
//                             </p>
//                             <div>+91 8072923994</div>
//                             {selectedValue === 'option1' && (
//                             <button className='p-2 rounded-md bg-buttonGreen text-white border'> Deliver to this Address </button>
//                             )}
//                             </div>
//                     </div>

//                     <div className='border p-3 mt-4  '>
//                         <div className='flex justify-between'>
//                             <div>
//                                 {/* <Radio
//                                     value="option2"
//                                      onChange={handleRadioChange}
//                                      checked={selectedValue === 'option2'}
//                                 /> */}
//                             </div>
//                             <div className='flex justify-between w-full '>
//                                 <div className='flex justify-between w-full'>

//                                     <div className='flex justify-between w-[20%]'>
//                                         <span className='font-semibold'>Hari haran </span>
//                                         <div className="text-primaryColor bg-secondaryColor  px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer">
//                                             Office
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div >
//                                 <Dropdown
//                                     menu={{ items, onClick: handleMenuClick1, }}
//                                     onOpenChange={handleOpenChange1}
//                                     open={open1}
//                                 >

//                                     <PiDotsThreeOutlineVerticalFill
//                                         style={{ cursor: "pointer", fontSize: "25px", }}
//                                     />
//                                 </Dropdown>
//                             </div>
//                         </div>
//                         <div className=''>
//                             <p>
//                                 Address:
//                                 <span className='font-light'> 29, south street, mount, chennai-600001</span>
//                             </p>
//                             <div>+91 8072923994</div>
//                             {/* {selectedValue === 'option2' && (
//                             <button className='p-2 rounded-md bg-buttonGreen text-white border'> Deliver to this Address </button>
//                         )} */}
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </Layouts>
//     )
// }

// export default MyAddress

import React, { useState, useEffect } from "react";
import Layouts from "../Layouts";
import Address from "../Pages/CartPage/Address";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { Dropdown, Radio, Spin, Empty } from "antd";
import { FiMapPin, FiPhone, FiPlus } from "react-icons/fi";
import authService from "../../Redux/Services/authService";
import { getCurrentUser } from "../../utils/auth";

const MyAddress = () => {
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAddresses = async () => {
    const user = getCurrentUser();
    if (!user) return;
    const userId = user.userId || user.userCode || localStorage.getItem("userCode");
    if (!userId) return;

    setLoading(true);
    try {
      const response = await authService.getAddress({ userId });
      if (response && response.data) {
        setAddresses(response.data);
        if (response.data.length > 0 && !selectedValue) {
          setSelectedValue(response.data[0].id || String(response.data[0].sno));
        }
      }
    } catch (err) {
      console.error("Failed to load addresses:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleEdit = (address) => {
    setSelectedAddress(address);
    setShowAddressModal(true);
  };

  const items = [
    {
      label: "Edit",
      key: "1",
    },
    {
      label: "Delete",
      key: "2",
      danger: true,
    },
  ];

  return (
    <Layouts>
      <div className="min-h-screen bg-[#FAF8F5] py-6 px-3 sm:px-5">
        {/* Main Container */}
        <div className="w-full max-w-xl mx-auto">

          {/* Header */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">

            <div className="bg-popButtoncolour px-4 py-3 flex items-center justify-between gap-3">
              <div>
                <h1 className="text-lg sm:text-xl font-semibold text-primaryColor">
                  My Addresses
                </h1>
                <p className="text-xs text-white mt-0.5">
                  Manage your delivery addresses
                </p>
              </div>

              <button
                onClick={() => {
                  setSelectedAddress(null);
                  setShowAddressModal(true);
                }}
                className="flex items-center gap-1.5 bg-primaryColor text-white px-3 py-2 rounded-lg text-xs sm:text-sm font-semibold hover:opacity-90 transition cursor-pointer whitespace-nowrap"
              >
                <FiPlus className="text-base" />
                Add Address
              </button>
            </div>

            {/* Address List */}
            <div className="p-3 sm:p-4">
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <Spin size="medium" />
                </div>
              ) : addresses.length === 0 ? (
                <div className="py-10 text-center">
                  <Empty description="No addresses saved yet. Click Add Address to save one." />
                </div>
              ) : (
                addresses.map((address) => {
                  const addrId = address.id || String(address.sno);
                  const fullAddressText = `${address.address1} ${address.address2 ? `, ${address.address2}` : ""} ${address.landmark ? `, Landmark: ${address.landmark}` : ""}, ${address.city}, ${address.state}, ${address.country} - ${address.pincode}`;

                  return (
                    <div
                      key={addrId}
                      className={`relative border rounded-lg p-3 sm:p-4 mb-3 last:mb-0 transition-all ${
                        selectedValue === addrId
                          ? "border-primaryColor bg-[#FFFDF7]"
                          : "border-gray-200 bg-white hover:border-gray-300"
                      }`}
                    >

                      {/* Top Section */}
                      <div className="flex items-start gap-2">

                        {/* Radio */}
                        <div className="pt-0.5">
                          <Radio
                            value={addrId}
                            checked={selectedValue === addrId}
                            onChange={handleRadioChange}
                          />
                        </div>

                        {/* Address Content */}
                        <div className="flex-1 min-w-0">

                          {/* Name + Type */}
                          <div className="flex items-center justify-between gap-2 pr-6">
                            <div className="flex items-center gap-2 min-w-0">
                              <h2 className="text-sm font-semibold text-gray-800 truncate">
                                {address.name}
                              </h2>

                              <span className="bg-secondaryColor text-primaryColor px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase">
                                {address.addressType || "HOME"}
                              </span>
                            </div>
                          </div>

                          {/* Address */}
                          <div className="flex items-start gap-2 mt-2">
                            <FiMapPin className="text-primaryColor text-sm mt-0.5 flex-shrink-0" />

                            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                              {fullAddressText}
                            </p>
                          </div>

                          {/* Phone */}
                          <div className="flex items-center gap-2 mt-1.5">
                            <FiPhone className="text-primaryColor text-sm" />

                            <span className="text-xs sm:text-sm text-gray-600">
                              {address.mobileNumber}
                            </span>
                          </div>

                          {/* Deliver Button */}
                          {selectedValue === addrId && (
                            <button
                              className="mt-3 px-3 py-1.5 rounded-md bg-buttonGreen text-white text-xs font-medium hover:opacity-90 transition cursor-pointer"
                            >
                              Deliver to this Address
                            </button>
                          )}
                        </div>

                        {/* Three Dot Menu */}
                        <div className="absolute top-3 right-2">
                          <Dropdown
                            menu={{
                              items,
                              onClick: ({ key }) => {
                                if (key === "1") {
                                  handleEdit(address);
                                }
                              },
                            }}
                            trigger={["click"]}
                          >
                            <PiDotsThreeOutlineVerticalFill
                              className="text-gray-500 hover:text-primaryColor cursor-pointer text-lg"
                            />
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>

        {/* Add / Edit Address Modal */}
        <Address
          visible={showAddressModal}
          onCancel={() => {
            setShowAddressModal(false);
            setSelectedAddress(null);
          }}
          onSuccess={fetchAddresses}
          address={selectedAddress}
        />
      </div>
    </Layouts>
  );
};

export default MyAddress;